//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { UIContext } from '@/contexts/UIContext';

/**
 * Access app-level UI preferences (nav display mode).
 */
export function useUI() {
  const context = useContext(UIContext);
  if (!context)
    throw new Error('useUI must be used within a UIProvider');

  return context;
}
